module.exports = __webpack_public_path__ + "static/img/krungsri-auto-logo-80.74cfec1.svg";